import { TourReadableTO, TourResponseTO } from "@/models/detail";
import { ETourOption } from "./common/enums";

export interface TourGAnalytics {
    item_id: string;
    item_name: string;
    price: number;
    item_brand: string;
    item_category: string;
    item_variant: string;
}

export interface AddToCartGAnalytics {
    item_id: string;
    item_name: string;
    price: number;
    item_brand: string;
    item_category: string;
    item_variant: string;
    affiliation: string;
    coupon: string;
    discount: number;
    index: number;
    item_list_id: string;
    number_people: number;
    number_rooms: number;
}

export const adapterItemGAnalytics = (
    item: TourReadableTO,
    variant: ETourOption
) => ({
    item_id: item.tourId,
    item_name: item.tourTitle,
    item_brand: "Play Italy",
    item_category: item.tourType,
    item_variant: variant,
    price: Number(item.price),
    quantity: 1,
});

const adapterTourViewItemGAnalytics = (
    tour: TourResponseTO,
    isPremium: boolean
) => {
    const productQuality = tour?.quality;
    const productPremium = tour?.premium;

    const itemVariant: ETourOption = isPremium
        ? ETourOption.PREMIUM
        : ETourOption.QUALITY;

    const item =
        itemVariant === ETourOption.PREMIUM && productPremium
            ? productPremium
            : productQuality;

    return {
        currency: "EUR",
        value: item?.price || 0.0,
        items: [adapterItemGAnalytics(item!, itemVariant)],
    };
};

export default adapterTourViewItemGAnalytics;
